// O backend às vezes devolve a mensagem de erro com o cabeçalho técnico do
// procedure SQL na frente (ex.: "Procedure: [ofv3_Chip].[SupplierInsert]\r\nErro: ...").
// Remove esse trecho antes de mostrar a mensagem pro usuário.
function stripProcedurePrefix(message) {
  if (!message) {
    return message;
  }
  return message.replace(/^\s*Procedure:\s*\[[^\]]+\]\.\[[^\]]+\]\s*[\r\n]+/i, "").trim();
}

// Backend de validação de campos retorna um array "validations": [{ field, message }].
// Junta todas as mensagens numa string só, uma por linha, pra exibir no toast.
function formatValidationErrors(validations) {
  if (!Array.isArray(validations) || validations.length === 0) {
    return null;
  }
  return validations.map((item) => item.message).filter(Boolean).join("\n");
}

// Escolhe a melhor mensagem pra mostrar ao usuário a partir do que os
// serviços devolvem em erro ({ message, friendlyMessage }). Em conflitos
// (409), o backend manda os dois: friendlyMessage é um texto genérico
// ("Não foi possível concluir a operação devido a um conflito...") e
// message é o motivo específico ("Já existe um contato cadastrado com os
// dados informados."). message é sempre o mais útil quando presente —
// friendlyMessage só entra como reforço/fallback, e o texto do chamador
// (fallback) só quando nenhum dos dois veio.
function getErrorMessage(response, fallback) {
  const specific = stripProcedurePrefix(response?.message);
  if (specific) return specific;

  const generic = stripProcedurePrefix(response?.friendlyMessage);
  if (generic) return generic;

  return fallback;
}

function handleResponse(response, area) {
  if (response.status === 204) {
    catchError(response, area, true);
    return null;
  }

  // Na prática o axios (config padrão, sem validateStatus customizado) já
  // rejeita a Promise pra qualquer status fora do range 2xx — então um 409
  // real cai no catch() de cada serviço, não aqui. Esse branch só existe
  // como rede de segurança caso `response` chegue como um response cru
  // (ex.: se algum dia um validateStatus passar a aceitar 409 como sucesso)
  // — por isso lê response.data (não response.response.data, como no catch)
  // e usa o mesmo helper de extração de mensagem que os serviços usam.
  if (response.status === 409) {
    catchError(response, area);
    return {
      error: true,
      status: 409,
      message: response.data?.message,
      friendlyMessage: response.data?.friendlyMessage,
      raw: response.data,
    };
  }

  if (response.status !== 200 && response.status !== 201 && response.status !== 202) {
    catchError(response.response, area);
    return {
      error: true,
      status: response.response?.status,
      friendlyMessage: response.response?.data?.friendlyMessage,
      message: response.response?.data?.message,
      raw: response.response?.data,
    };
  }

  if (response.data)
    return response.data.result ? response.data.result : response.data;

  return response.result;
}

function catchError(error, area, warning) {
  try {
    let message = "Error: " + (error?.status ? error?.status : error?.code);
    message += " | Local: " + area;
    message +=
      " | Status: " +
      (error?.statusText ? error?.statusText : error?.response?.status);
    if (error?.response?.data) {
      if (error?.response?.data.error) {
        message += " | Messages: " + error.response.data.error;
      }
    }
    if (!warning) {
      console.log(message);
    } else {
      console.warn(message);
    }
  } catch (ex) {
    console.log(ex);
  }
}

export const errorHandling = {
  handleResponse,
  cathError: catchError,
  stripProcedurePrefix,
  formatValidationErrors,
  getErrorMessage,
};
